// extracted by mini-css-extract-plugin
module.exports = {"userDetailsGrid":"user-details_userDetailsGrid__1MvRg","transactions":"user-details_transactions__30c7X","payment":"user-details_payment__27wei"};